import { useInstance } from 'intact-vue';
import { swap } from '../utils';
export function useDraggable() {
  var instance = useInstance();
  return function onEnd(_ref) {
    var key = _ref.key,
      from = _ref.from,
      to = _ref.to;
    instance.set('value', swap(instance.get('value'), from, to));
  };
}